import React from 'react';
import { Grid } from '@material-ui/core';
import { withFormik, FormikProps } from 'formik';
import { translate } from 'helpers/intl';
import { IntlShape, injectIntl } from 'react-intl';
import { get, includes, filter } from 'lodash';

import InputField from 'components/InputField';
import { OrangeButton } from 'components/Button';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import messages from 'components/MapFilter/messages';

const FaqFilter = (
  props: {
    faq: FaqItem[];
    setSearchFaq: Function;
    getFaq: Function;
  } & FormikProps<FormValues>,
) => {
  const { values, handleSubmit, handleChange, handleBlur } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <InputField
            placeholder={translate(get(messages, 'research'), props)}
            name="research"
            value={values.research}
            handleChange={handleChange}
            handleBlur={handleBlur}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
            InputProps={{
              'data-testid': 'research',
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <OrangeButton type="submit" variant="contained">
            {translate(get(messages, 'research'), props)}
          </OrangeButton>
        </Grid>
      </Grid>
    </form>
  );
};

interface FormValues {
  research: string;
}
interface FaqBody {
  code: string;
  question: string;
  reponse: string;
  language: string;
  section: string;
  tags: string;
  id: number;
}
interface FaqItem {
  code: string;
  body: FaqBody[];
}

export interface FormProps {
  intl: IntlShape;
  faq: FaqItem[];
  setSearchFaq: Function;
  getFaq: Function;
}
const EnhancedFaqFilter = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      research: '',
    };
  },
  handleSubmit: ({ research }, { props }) => {
    if (!research) {
      props.getFaq();
    }
    const ids: number[] = [];
    props.faq.forEach((group: FaqItem) => {
      group.body.forEach((groupBody: FaqBody) => {
        if (includes(groupBody.tags, research)) {
          ids.push(groupBody.id);
        }
      });
    });
    let result = props.faq.map((item) => {
      const body = filter(item.body, (element: FaqBody) =>
        ids.includes(element.id),
      );
      return {
        ...item,
        body,
      };
    });
    result = filter(result, (item: FaqItem) => item.body.length > 0);
    props.setSearchFaq(result);
  },
})(FaqFilter);
export default injectIntl(EnhancedFaqFilter);
